import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import { AddPlatformModalComponent } from 'app/modules/well-header-information/pages/assets/field/add-platform-modal/add-platform-modal.component';
import { EditFieldModalComponent } from 'app/modules/well-header-information/pages/assets/field/edit-field-modal/edit-field-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FieldClass } from 'app/modules/well-header-information/model/assets.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-field',
  templateUrl: './field.component.html',
  standalone: true,
  imports: [
    NgClass
  ],
  styleUrls: ['./field.component.scss']
})
export class FieldComponent {
  public field: FieldClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }
  
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let fieldId = params.get('fieldId');
      this.getField(fieldId)
    });
  }

  getField(id: any) {
    this.wellHeaderService.getFieldById(id).subscribe((res) => {
      
      this.field = {
        fieldId: res.data.id,
        pscId: res.data.regionId,
        name: res.data.fieldShortName,
        longName: res.data.fieldLongName,
        createdDate: res.data.inputDate,
        block: res.data.blockName,
        status: res.data.fieldStatus,
        remarks: res.data.remark,
        region: res.data.regionName,
        companyName: res.data.companyName,
        level: 'field'
      };
    })
  }

  addPlatformModal(fieldDetails: any) {
    const dialogRef = this.dialog.open(AddPlatformModalComponent, {
      data: fieldDetails.fieldId,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.wellHeaderService.getAssetTree().subscribe()
        this.wellHeaderService.updateParentsNode([this.field.pscId,this.field.fieldId])
      }
    });
  }

  editFieldModal(fieldDetails: any) {
    const dialogRef = this.dialog.open(EditFieldModalComponent, {
      data: fieldDetails,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getField(fieldDetails.fieldId)
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
